export default "__VITE_ASSET__804305f7__"